// extracted by mini-css-extract-plugin
module.exports = {"trackingEvents":"sG","trackingEvent":"tG","dailyEvent":"uG","desciptionLocation":"vG","time":"wG","location":"xG"};